import React, { PureComponent } from 'react'
import { Router, Link, Switch, Route } from 'react-static'
import { hot } from 'react-hot-loader'
import { compose } from 'recompose'
import { Grid, Divider, Typography, Button, CssBaseline, withStyles, withTheme, AppBar, IconButton, Toolbar, Badge, BottomNavigation, BottomNavigationAction, Tabs, Tab, Paper, Hidden } from '@material-ui/core'
import Routes from 'react-static-routes'
import SvgIcon from '@material-ui/core/SvgIcon'
import SearchIcon from '@material-ui/icons/Search'
import TrackChangesIcon from '@material-ui/icons/TrackChanges'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Footer from 'components/Footer'
import 'App.css'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  bottomNav: {
    position: 'fixed',
    bottom: '0px',
    width: '100%',
    zIndex: 10000,
  },
  flex: {
    flex: 1,
  },
  flex2: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

function AltEmailIcon (props) {
  return (
    <SvgIcon {...props}>
      <path fillOpacity=".9" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </SvgIcon>
  )
}

function BeakerIcon (props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 16 16"><path fillRule="evenodd" d="M14.38 14.59L11 7V3h1V2H3v1h1v4L.63 14.59A1 1 0 0 0 1.54 16h11.94c.72 0 1.2-.75.91-1.41h-.01zM3.75 10L5 7V3h5v4l1.25 3h-7.5zM8 8h1v1H8V8zM7 7H6V6h1v1zm0-3h1v1H7V4zm0-3H6V0h1v1z" /></svg>
    </SvgIcon>
  )
}

const NoMatch = () => (
  <React.Fragment>
    <div style={{
 zIndex: -10, position: 'sticky', top: 0, height: '100vh', backgroundColor: 'olive', overflow: 'hidden',
}} />
    <div style={{
 zIndex: 10, position: 'absolute', top: 0, height: '50vh', width: '100vw', display: 'table',
}} >
      <div style={{ animation: 'fadeinText 3s', display: 'table-row', height: '100vh' }} >
        <div style={{ display: 'table-cell', textAlign: 'center', verticalAlign: 'middle' }} >
          Hello World...
        </div>
      </div>
    </div>
  </React.Fragment>
)

class App extends PureComponent {
  state = {
    value: 0,
    searching: false,
  }
  componentDidMount () {
    const jssStyles = document.getElementById('jss-server-side')
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles)
    }
  }
  handleChange = (event, value) => {
    this.setState({ value })
  };
  render () {
    const { classes, theme } = this.props
    const { value, searching } = this.state
    return (
      <Router autoScrollToTop={true} autoScrollToHash={false} >
        <React.Fragment>
          <CssBaseline />
          {/* <Route exact path="/" component={NoMatch} /> */}
          {/* <AppBar position="sticky" color="default" >
            <Toolbar>
              <IconButton to="/radar" component={Link} color="inherit" aria-label="KV" > <TrackChangesIcon /> </IconButton>
              <div className={classes.flex} />
              <IconButton to={{ pathname: '/', hash: '#test' }} component={Link} color="inherit" aria-label="KV" > <AccountCircle /> </IconButton>
              <div className={classes.flex} />
              <IconButton to="/search" component={Link} color="inherit" aria-label="Search" > <SearchIcon /> </IconButton>
            </Toolbar>
          </AppBar> */}
          <Routes />
          {/* TODO: BUG: DEV: Put this footer back for site to work this was just for a push */}
          {/* <Route path="(..+)" render={props => (<Footer {...props} />)} /> */}
          <Route path="(.+)" render={props => (<Footer {...props} />)} />
        </React.Fragment>
      </Router>
    )
  }
}

// const AppWithStyles = withStyles(styles)(App)
const AppWithStyles = compose(
  withTheme(),
  withStyles(styles)
)(App)

export default hot(module)(AppWithStyles)



// WEBPACK FOOTER //
// /Users/evank/Documents/dev/kyle.ventures/src/App.js